<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="padding-bottom:20px;">About the Author</h1>
<p style="text-indent:00em;"><em>Am I Dead Again?</em> is Karin H. Kerr’s first full-length novel, but it is not her first venture in writing. At the University of Calgary, she produced and edited television newsmagazine programs. She wrote and delivered stimulating backgrounders as a radio DJ. She scripted several video productions for private enterprises. She prepared a weekly column about country music artists. She has recently written a children’s book. She’s also been in several rock and roll bands, sings in a choir, and teaches piano and guitar.</p>
<br/>
<p style="text-indent:00em;">She holds a bachelor’s degree in English literature, a diploma in radio and television arts and is certified in multimedia.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?375d548e